import { ReactNode } from "react";
import { NavLink } from "react-router-dom";

export default function AppNavLink({
  to,
  baseClassName,
  activeClassName,
  inactiveClassName,
  children,
  clicked,
}: {
  to: string;
  baseClassName: string;
  activeClassName: string;
  inactiveClassName?: string;
  children: ReactNode;
  clicked?: () => void;
}) {
  return (
    <NavLink
      to={to}
      className={(navData) =>
        navData.isActive
          ? baseClassName + " " + activeClassName
          : baseClassName + " " + inactiveClassName
      }
      onClick={clicked}>
      {children}
    </NavLink>
  );
}
